"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIE_OPTIONS = void 0;
exports.COOKIE_OPTIONS = {
    domain: '.headbox.com',
    path: '/',
    secure: true
};
